export const loadPayPalScript = (clientId, currency = "USD") =>
  new Promise((resolve, reject) => {
    if (window.paypal) return resolve(true);
    const s = document.createElement("script");
    s.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&currency=${currency}`;
    s.onload = () => resolve(true);
    s.onerror = () => reject(new Error("PayPal checkout failed to load"));
    document.body.appendChild(s);
  });
